import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { AuthenticationModule } from './auth/authentication.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BlockUIModule } from 'ng-block-ui';

import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

// import { ServiceWorkerModule } from '@angular/service-worker';
import { AppRoutingModule } from './app.routing';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { AppConfig } from './app.config';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ToasterModule } from 'angular2-toaster/src/toaster.module';
import { HeaderService } from './components/app-header/app.header.service';
import { ErrorsComponent } from './errors/errors.component';
import { PipesModule } from './restricted/pipe/PipesModule';
import { LocalUtils } from './restricted/restricted.utils';

export function localUtilsFactory(http: HttpClient): LocalUtils {
  return new LocalUtils(http);
}

@NgModule({
  imports: [
    // ServiceWorkerModule.register('/ngsw-worker.js', { enabled: true }),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthenticationModule,
    HttpClientModule,
    ToasterModule,
    BlockUIModule.forRoot(),
    FormsModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ModalModule.forRoot(),
    ChartsModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger'
    }),
    PipesModule,
  ],
  declarations: [
    AppComponent,
    ErrorsComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
  ],
  providers: [
    AppConfig,
    HeaderService,
    ErrorsComponent,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: LocalUtils,
      useFactory: localUtilsFactory,
      deps: [HttpClient]
    },
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts